import { createBrowserRouter, Navigate } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { AccountPage } from "@/pages/account/index";
import { DevicesPage } from "@/pages/devices/index";
import { FindingsPage } from "@/pages/findings/index";
import { HaltPage } from "@/pages/halt/index";
import { LiveDashboardPage } from "@/pages/live-dashboard/index";
import { NotificationsPage } from "@/pages/notifications/index";
import { ReportsPage } from "@/pages/reports/index";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Navigate to="/live" replace /> },
      { path: "live", element: <LiveDashboardPage /> },
      { path: "reports", element: <ReportsPage /> },
      { path: "findings", element: <FindingsPage /> },
      { path: "devices", element: <DevicesPage /> },
      { path: "notifications", element: <NotificationsPage /> },
      { path: "account", element: <AccountPage /> },
      { path: "halt", element: <HaltPage /> },
    ],
  },
]);
